const emailHistory = [
  {
    id: 1,
    subject: "Subscription Expiring Soon - Action Required",
    recipient: "john.smith@acme.com",
    dateSent: "September 8, 2025",
    timeSent: "10:30 AM",
    status: "Delivered",
    statusColor: "#00FF4C",
    emailType: "Welcome",
    openRate: "95%",
  },
  {
    id: 2,
    subject: "Subscription Expiring Soon - Action Required",
    recipient: "john.smith@acme.com",
    dateSent: "September 8, 2025",
    timeSent: "2:15 PM",
    status: "Opened",
    statusColor: "#FFB800",
    emailType: "Reminder",
    openRate: "87%",
  },
  {
    id: 3,
    subject: "Subscription Expiring Soon - Action Required",
    recipient: "john.smith@acme.com",
    dateSent: "September 8, 2025",
    timeSent: "9:00 AM",
    status: "Delivered",
    statusColor: "#00FF4C",
    emailType: "Report",
    openRate: "72%",
  },
  {
    id: 4,
    subject: "Subscription Expiring Soon - Action Required",
    recipient: "john.smith@acme.com",
    dateSent: "September 8, 2025",
    timeSent: "4:45 PM",
    status: "Failed to send",
    statusColor: "#FF4444",
    emailType: "Security",
    openRate: "0%",
  },
];

export default function SentEmailHistory() {
  return (
    <div className="bg-black-950 flex flex-col gap-5 rounded-lg p-5">
      <div className="flex flex-row items-center justify-between">
        <div className="space-y-2">
          <div className="text-lg leading-5 font-bold -tracking-wide text-white">
            Sent Email History
          </div>
          <div className="text-black-500 text-xs leading-3">
            Recent notification emails sent to this client{" "}
          </div>
        </div>
      </div>

      {/* Header */}
      <div className="grid grid-cols-4 gap-4 px-4 py-3">
        <div className="text-black-500 text-xs font-medium tracking-wide uppercase">
          Subject
        </div>
        <div className="text-black-500 text-xs font-medium tracking-wide uppercase">
          Date Sent
        </div>
        <div className="text-black-500 text-xs font-medium tracking-wide uppercase">
          Recipient
        </div>

        <div className="text-black-500 text-xs font-medium tracking-wide uppercase">
          Status
        </div>
      </div>

      {/* Email List */}
      <div className="flex flex-col gap-2">
        {emailHistory.map((email) => (
          <div
            key={email.id}
            className="bg-black-900/50 hover:bg-black-900/80 grid grid-cols-4 gap-4 rounded-lg px-4 py-4 transition-colors"
          >
            <div className="truncate text-sm font-medium text-white">
              {email.subject}
            </div>
            <div className="text-black-white truncate text-sm">
              {email.dateSent}
            </div>
            <div className="text-sm text-white">{email.recipient}</div>

            <div className="flex items-center gap-2">
              <div
                className="h-2 w-2 rounded-full"
                style={{ backgroundColor: email.statusColor }}
              ></div>
              <span className="text-sm font-medium text-white">
                {email.status}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
